// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_N62Ck { 
  flex : 0 0 auto;
  width : 160px;
  height : 96px;
  object-fit : contain;
  background : var( --color-white );
  padding : 8px 16px;
  border : 1px solid var( --color-base200 );
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/attributes/image/ImageEditor.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,yCAAyC;AAC3C","sourcesContent":[".image { \n  flex : 0 0 auto;\n  width : 160px;\n  height : 96px;\n  object-fit : contain;\n  background : var( --color-white );\n  padding : 8px 16px;\n  border : 1px solid var( --color-base200 );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image_N62Ck`
};
export default ___CSS_LOADER_EXPORT___;
